<template lang="pug">
    div.progress-line-control
        div.progress-line-control__lines
            div.progress-line-control__left(:style='progressLeftStyle')
            div.progress-line-control__right(:style='progressRightStyle')
</template>

<script>
export default {
    name: 'progress-line-control',
    props: {
        value: {
            type: Number,
            required: true,
        },
    },
    computed: {
        percent() {
            return parseInt(this.value) || 0
        },
        progressLeftStyle() {
            return {
                'width': this.percent + '%',
            }
        },
        progressRightStyle() {
            return {
                'width': (100 - this.percent) + '%',
            }
        },
    },
}
</script>
